import angular from 'angular';
import MostSelledProductsComponent from './most-selled-products.component';

let MostSelledProductsModule = angular.module('catalog.mostSelledProducts', [])
  .component('mostSelledProducts', MostSelledProductsComponent);

export default MostSelledProductsModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/most-selled-products/most-selled-products.js
 **/